/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {findNearbySelector, selectedToolSelector} from '@/store/selectors/tracking-selectors';
import {BreadcrumbsType} from '@/types/sidesheet';
import {getToolCrumb, initialCrumb} from './utils';

/**
 * @useAssociatedTagsCrumb
 * React Hook to create an associated tags crumb
 * 
 *  ```typescript
 *   import {useAssociatedTagsCrumb} from '@/routes/tracking/hooks';
 * 
 *   const [tagsDetailsCrumb] = useAssociatedTagsCrumb();
 *  ```
 */
export const useAssociatedTagsCrumb = () => {
  const [crumbs, setCrumbs] = useState<BreadcrumbsType>(initialCrumb);
  const selectedTag         = useSelector(selectedToolSelector);
  const findLabel           = useSelector(findNearbySelector);
  
  useEffect(() => {
    if (selectedTag && !findLabel?.miles) {
      const tagsBrumb = getToolCrumb(selectedTag);
      setCrumbs(tagsBrumb);
    } else if (!selectedTag || !!findLabel?.miles) {
      setCrumbs(initialCrumb);
    }
  }, [selectedTag, findLabel]);
  return [crumbs];
};
